import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-amber-50 border border-amber-300 rounded-xl p-5 flex items-start gap-3" }
const _hoisted_2 = { class: "min-w-0" }
const _hoisted_3 = { class: "font-semibold text-amber-900 mb-1" }
const _hoisted_4 = { class: "text-sm text-amber-800 mt-2" }

import { Icon } from '@iconify/vue'
import { useModeStore } from '../store/mode'


export default /*@__PURE__*/_defineComponent({
  __name: 'EnvironmentUnavailable',
  setup(__props) {

const modeStore = useModeStore()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Icon), {
      icon: "solar:danger-triangle-bold",
      class: "w-6 h-6 text-amber-700 flex-shrink-0 mt-0.5"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, " Environnement " + _toDisplayString(_unref(modeStore).isTest ? 'de test' : 'de production') + " indisponible ", 1),
      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-sm text-amber-800" }, " Votre session est bien active, mais cet environnement ne reconnaît pas encore votre compte. C'est en général temporaire, le temps que votre accès y soit propagé. ", -1)),
      _createElementVNode("p", _hoisted_4, [
        _cache[1] || (_cache[1] = _createTextVNode(" Vous pouvez continuer sur l'environnement ", -1)),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(modeStore).toggle())),
          class: "font-semibold underline hover:no-underline"
        }, _toDisplayString(_unref(modeStore).isTest ? 'de production' : 'de test'), 1),
        _cache[2] || (_cache[2] = _createTextVNode(" en attendant, ou contacter le support Youdégo si cela persiste. ", -1))
      ])
    ])
  ]))
}
}

})